import React, { useState, SyntheticEvent, ReactNode } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useConfirm } from "material-ui-confirm";
import { dialogOptions } from "../leave-confirm-prompt/leave-confirm-dialog-options"
interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box paddingTop={3}>
          {children}
        </Box>
      )}
    </div>
  );
};

export const TabPanels = (props: any) => {
  return (
    <>
    {props.children.map((tab: any, index: number) => (
      <TabPanel value={props.value} index={index} key={index} >
        {tab}
      </TabPanel>
    ))}
    </>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface TabTitleProps {
  tabLabels: string[];
  value: number;
  setValue: (value:number) => void;
  showLeavePrompt: boolean;
  setShowLeavePrompt: (bool: boolean) => void;
}

export const TabTitle = (props: TabTitleProps) => {
  const confirm = useConfirm();
  const {t} = useTranslation();
  const { tabLabels, showLeavePrompt, setShowLeavePrompt, value, setValue } = props;
  const handleChange = (event: SyntheticEvent, newValue: number) => {
    if(showLeavePrompt) {
      confirm(dialogOptions)
      .then(() => {setValue(newValue); setShowLeavePrompt(false);})
      .catch(() => console.log("cancelled"));
    } else {
      setValue(newValue);
    } 
  };

  return (
    <Tabs value={value} onChange={handleChange} aria-label="tabs"   sx={{
      '.MuiTabs-indicator': {background:"var( --kyocera-blue)", width: "inherit", height: "3px", bottom: "5px"}, 
      '.MuiButtonBase-root': {minWidth: "inherit", paddingX: "2px", marginX: "10px", paddingY: 0},
    }}>
      {tabLabels.map((tab: any, index: number) => (
        <Tab
        sx={{
          textTransform: "capitalize",
          '&.Mui-selected': { fontWeight: "bolder", color: "#000"}, 
        }}
          key={index}
          label={t("tabs." + tab)}
          {...a11yProps(index)}
        />
      ))}
    </Tabs>
  )
}